import { render, staticRenderFns } from "./sba-tags.vue?vue&type=template&id=733f6352&"
import script from "./sba-tags.vue?vue&type=script&lang=js&"
export * from "./sba-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports